export const STATUS_BAR_SLOTS = ['left', 'center', 'right'];

export const EMPTY_STATUS_PANEL_GROUPS = Object.freeze({ left: [], center: [], right: [] });

const isReactStatusPanel = (statusPanel) =>
  typeof statusPanel === 'function' || (typeof statusPanel === 'object' && statusPanel !== null);

export const hasStatusPanels = (statusBar) =>
  Array.isArray(statusBar?.statusPanels) && statusBar.statusPanels.length > 0;

// Panels registered by name (AG Grid built-ins) cannot be rendered through React slots.
export const canSlotStatusPanels = (statusBar) =>
  hasStatusPanels(statusBar) &&
  statusBar.statusPanels.every((panel) => isReactStatusPanel(panel?.statusPanel));

// Mirrors AG Grid: a panel without `align` renders on the right, an unknown `align` is dropped.
export const groupStatusPanels = (statusBar) => {
  if (!canSlotStatusPanels(statusBar)) return EMPTY_STATUS_PANEL_GROUPS;

  const groups = { left: [], center: [], right: [] };
  statusBar.statusPanels.forEach((panel) => groups[panel.align ?? 'right']?.push(panel));
  return groups;
};

export const createSlotStatusBar = (SlotComponent) => ({
  statusPanels: STATUS_BAR_SLOTS.map((slot) => ({
    key: `ag-table-status-${slot}`,
    align: slot,
    statusPanel: SlotComponent,
    statusPanelParams: { slot }
  }))
});
